module.exports = __webpack_public_path__ + "static/media/Back.037528ac.svg";